import { render, staticRenderFns } from "./FormSpecialty.vue?vue&type=template&id=93237d30"
import script from "./FormSpecialty.vue?vue&type=script&lang=js"
export * from "./FormSpecialty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports